import { render, staticRenderFns } from "./CardInfoV1.vue?vue&type=template&id=2c294cf0&scoped=true&"
import script from "./CardInfoV1.vue?vue&type=script&lang=js&"
export * from "./CardInfoV1.vue?vue&type=script&lang=js&"
import style0 from "./CardInfoV1.vue?vue&type=style&index=0&id=2c294cf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c294cf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c294cf0')) {
      api.createRecord('2c294cf0', component.options)
    } else {
      api.reload('2c294cf0', component.options)
    }
    module.hot.accept("./CardInfoV1.vue?vue&type=template&id=2c294cf0&scoped=true&", function () {
      api.rerender('2c294cf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/CardInfo/Agent/CardInfoV1.vue"
export default component.exports